import request from "@/utils/request";

export function replace(input) {
   if (input.indexOf("±") != -1) {
      return input.replace(/\s*/g, "").replaceAll("\uFEFF", "").replaceAll("max", "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("±")[0]
   } else if (input.indexOf("+") != -1) {
      return input.replace(/\s*/g, "").replaceAll("\uFEFF", "").replaceAll("max", "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("+")[0].split("-")[0]
   } else if (input.indexOf("-") != -1) {

      return input.replace(/\s*/g, "").replaceAll("\uFEFF", "").replaceAll("max", "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("-")[0].split("+")[0]
   } else {

      return input.replace(/\s*/g, "").replaceAll("\uFEFF", "").replaceAll("max", "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "")
   }

}
